export default "__VITE_ASSET__4787a22f__"